/**
  TombstoneOperations is a suppression map.
  We add to the tombstone list after doing a client operation and we want
  to suppress ( or do special processing on) server notifications for this row until
  we get correct notification which indicates the completion of the operation server-side
 */

// Registering orchestrators
import './orchestrators/addToTombstoneOrchestrator';
import './orchestrators/removeFromTombstoneOrchestrator';

// Export tombstone actions
export { default as addToTombstone } from './actions/addToTombstone';
export { default as removeFromTombstone } from './actions/removeFromTombstone';

// Export utils
export { default as getTombstonedReasons } from './utils/getTombstonedReasons';

// Export public types
export { default as TombstoneReasonType } from './store/schema/TombstoneReasonType';
